import { ViewIcon, ViewOffIcon } from '@chakra-ui/icons';
import {
    FormControl,
    FormLabel,
    IconButton,
    Input,
    InputGroup,
    InputRightElement,
} from '@chakra-ui/react';
import { useRef, useState } from 'react';

import { PasswordValidationPopover } from '@/v5/components/molecules/Password/PasswordValidationPopover';

function PasswordValidationField({
    label = 'Password',
    isRequired = true,
    isOpen = false,
    field,
    form,
    ...inputProps
}) {
    const [showPassword, setShowPassword] = useState(false);
    const isInvalid = Boolean(
        form.errors[field.name] && form.touched[field.name],
    );
    const initialFocusRef = useRef();

    const handleToggleShowPassword = () => setShowPassword(!showPassword);

    const inputElement = (
        <FormControl isRequired={isRequired} isInvalid={isInvalid}>
            <FormLabel htmlFor={field.name}>{label}</FormLabel>
            <InputGroup>
                <Input
                    {...field}
                    id={field.name}
                    type={showPassword ? 'text' : 'password'}
                    autoComplete="new-password"
                    placeholder="Enter your new password"
                    ref={initialFocusRef}
                    {...inputProps}
                />
                <InputRightElement h="full">
                    <IconButton
                        variant="ghost"
                        onClick={handleToggleShowPassword}
                        icon={
                            showPassword ? (
                                <ViewIcon boxSize="5" />
                            ) : (
                                <ViewOffIcon boxSize="5" />
                            )
                        }
                        aria-label={
                            showPassword ? 'Hide password' : 'Show password'
                        }
                        _focus={{ boxShadow: 'none' }}
                        _hover={{ background: 'none', color: 'brand.600' }}
                        color={showPassword ? 'brand.600' : 'gray.500'}
                    />
                </InputRightElement>
            </InputGroup>
        </FormControl>
    );

    return (
        <PasswordValidationPopover
            initialFocusRef={initialFocusRef}
            isOpen={isOpen}
            password={field.value}>
            {inputElement}
        </PasswordValidationPopover>
    );
}

export { PasswordValidationField };
